import React from 'react';
import './Plan.css'; // Import your CSS file

import { Button } from '../../components';

import { FaCheck } from 'react-icons/fa';



const Plan = ({ plan }) => {

  const { title, content, price, features } = plan;

  return (
    <div className="plan-item">

      <div className='intro'>
        <h3>{title}</h3> {/* Plan Title */}
        <p>{content}</p> {/* Plan Content */}
        <div className='price'>${price} <span>/month</span></div> {/* Plan Price */}
      </div>

      {/* List of Features */}
      <ul>
        {features.map((feature, index) => (
          <li key={index}><div className='icon'><FaCheck /></div> {feature}</li> 
        ))}
      </ul>

      <Button link={"Get-Quote"} title={"Choose Plan"} />

    </div>
  );
};

export default Plan;